import { render, staticRenderFns } from "./homeChangeScene.vue?vue&type=template&id=0b906b68&scoped=true&"
import script from "./homeChangeScene.vue?vue&type=script&lang=js&"
export * from "./homeChangeScene.vue?vue&type=script&lang=js&"
import style0 from "./homeChangeScene.vue?vue&type=style&index=0&id=0b906b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b906b68",
  null
  
)

export default component.exports